module.exports = __webpack_public_path__ + "img/show_cn_text_15.025ca560.png";